import Api from "./Api";

export default class FeaturedImage {
    static getSpeakerFeaturedImageUrl(speaker, small = true) {
        return small ? this.getSmallFeaturedImageUrl(speaker) : this.getBiggerFeaturedImageUrl(speaker);
    }

    static getSmallFeaturedImageUrl(speaker) {
        if ('photo' in speaker && speaker['photo'] !== null) {
            if ('thumbnail' in speaker['photo']) {
                return speaker['photo']['thumbnail'];
            }

            if ('medium' in speaker['photo']) {
                return speaker['photo']['medium'];
            }

            if ('large' in speaker['photo']) {
                return speaker['photo']['large'];
            }

            if ('original' in speaker['photo']) {
                return speaker['photo']['original'];
            }
        }

        return new Api().mountImageRootPath('profile-image-not-found.jpg');
    }

    static getBiggerFeaturedImageUrl(speaker) {
        if ('photo' in speaker && speaker['photo'] !== null) {
            if ('original' in speaker['photo']) {
                return speaker['photo']['original'];
            }

            if ('large' in speaker['photo']) {
                return speaker['photo']['large'];
            }

            if ('medium' in speaker['photo']) {
                return speaker['photo']['medium'];
            }

            if ('thumbnail' in speaker['photo']) {
                return speaker['photo']['thumbnail'];
            }
        }

        return new Api().mountImageRootPath('profile-image-not-found.jpg');
    }
}
